import { CommonModule, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_DROPDOWNLIST } from '@progress/kendo-angular-dropdowns';
import { CardModule } from '@progress/kendo-angular-layout';
import { ToastrService } from 'ngx-toastr';
import { LogoService } from '../../../@theme/services/logo.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'gd-logo-manager',
    templateUrl: './logo-manager.component.html',
    styleUrls: ['./logo-manager.component.scss'],
    imports: [
      CommonModule,
      ReactiveFormsModule,
        CardModule,
        CommonModule,
        KENDO_DROPDOWNLIST,
        FormsModule,
        NgIf,
        KENDO_BUTTON,
    ]
})
export class LogoManagerComponent implements OnInit {
  logoFileData: any[]
  selectedLogo: any
  assetsPath = environment.assetsPath;
  constructor(
    private logoService: LogoService,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    this.logoService.getLogos().subscribe((response) => {
      this.logoFileData = response
    })
  }

  updateLoginLogo() {
    this.logoService
      .saveLogo({
        logoType: 0,
        logoFileName: this.selectedLogo.logoFileName,
      })
      .subscribe({
        next: () => {
          this.toastr.success('Logo has been updated')
        },
        error: () => {
          this.toastr.error('There was an error updating the logo')
        },
      })
  }
}
